import { useLogFilenames } from "@api/logs";
import DataGrid from "@components/DataGrid/DataGrid";
import i18n from "@i18n/i18n";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button, Link } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { observer } from "mobx-react";
import { useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useResizeObserver from "use-resize-observer";

const ApplicationLogsGrid = observer(() => {
  const containerRef = useRef(null);
  const { height } = useResizeObserver({ ref: containerRef });
  const logFilenames = useLogFilenames();
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "download",
      headerName: i18n.t("application-logs-tab.columns.download"),
      flex: 1,
      renderCell: (params: any) => {
        return (
          <a href={`/api/logs/${logFilenames.data![params.id]}`} download key={params.row.id + "_col2"}>
            <Button variant="contained" onClick={(e) => e.stopPropagation()} startIcon={<DownloadIcon />}>
              {i18n.t("application-logs.download-button.title")}
            </Button>
          </a>
        );
      },
    },
    {
      field: "name",
      headerName: i18n.t("application-logs-tab.columns.name"),
      flex: 1,
      renderCell: (params: any) => {
        return (
          <Link
            component="button"
            key={params.row.id + "_col1"}
            onClick={() => {
              window.open(`/api/logs/${logFilenames.data![params.id]}`, "_blank");
            }}
          >
            {logFilenames.data![params.id]}
          </Link>
        );
      },
    },
  ];

  const rows = useMemo(() => {
    return (
      logFilenames.data?.map((log: string, index: number) => {
        return { id: index, name: log };
      }) ?? []
    );
  }, [logFilenames.data]);

  return (
    <Box ref={containerRef} sx={{ width: "100%", height: "100%" }}>
      <DataGrid
        loading={logFilenames.isFetching}
        rows={rows}
        columns={columns}
        initialState={{
          sorting: {
            sortModel: [{ field: "name", sort: "desc" }],
          },
        }}
        sx={{ height: `${(height || 400) - 16}px` }}
      />
    </Box>
  );
});

export default ApplicationLogsGrid;
